/**
 * Schedule Options Constants
 * 
 * These constants define the available schedule options for subtasks
 * based on template types and their corresponding display labels in German.
 */

export interface ScheduleOption {
  id: string;
  name: string;
}

/**
 * Mapping of schedule option IDs to their German display labels
 * Single source of truth for all schedule option translations
 */
export const SCHEDULE_OPTION_LABELS: Record<string, string> = {
  "1_week": "In einer Woche neu anlegen",
  "2_weeks": "In zwei Wochen neu anlegen",
  "4_weeks": "In vier Wochen neu anlegen",
  "1_month": "In einem Monaten neu anlegen",
  "3_months": "In 3 Monaten neu anlegen",
  "6_months": "In 6 Monaten neu anlegen",
  "end_task": "Keine neuen Proben geplant",
  "schedule": "Wie soll es weitergehen?",
};

/**
 * Helper function to create schedule options from IDs
 */
const createScheduleOptions = (ids: string[]): ScheduleOption[] => {
  return ids.map((id) => ({
    id,
    name: SCHEDULE_OPTION_LABELS[id] || id,
  }));
};

/**
 * Schedule options for VKA_Vorlage (On-site) template type
 */
export const VKA_VORLAGE_SCHEDULE_OPTIONS: ScheduleOption[] = createScheduleOptions([
  "1_week",
  "2_weeks",
  "4_weeks",
  "end_task",
]);

/**
 * Schedule options for Labor_VKA (Laboratory) template type
 */
export const LABOR_VKA_SCHEDULE_OPTIONS: ScheduleOption[] = createScheduleOptions([
  "1_month",
  "3_months",
  "6_months",
  "end_task",
]);

/**
 * Schedule options for 42BimschV Untersuchung completion
 */
export const BIMSCHV_COMPLETION_OPTIONS: ScheduleOption[] = createScheduleOptions([
  "3_months",
  "6_months",
  "sonderprobe",
  "no_new_samples",
]);

// Update labels for 42BimschV completion options
SCHEDULE_OPTION_LABELS["3_months"] = "In 3 Monaten neu anlegen";
SCHEDULE_OPTION_LABELS["6_months"] = "In 6 Monaten neu anlegen";
SCHEDULE_OPTION_LABELS["sonderprobe"] = "Das war eine Sonderprobe";
SCHEDULE_OPTION_LABELS["no_new_samples"] = "Keine neuen Proben geplant";

